"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["p[_ngcontent-%COMP%]{margin:0}@media (width < 900px){.desktop[_ngcontent-%COMP%]{display:none}}@media (width > 900px){.mobile[_ngcontent-%COMP%]{display:none}}a[_ngcontent-%COMP%]{text-decoration:none}.hideClass[_ngcontent-%COMP%]{display:none!important}.showClass[_ngcontent-%COMP%]{display:block!important}"];
exports.styles = styles;

